module.exports = __webpack_public_path__ + "img/ye.22b9460e.png";